// extracted by mini-css-extract-plugin
export default {"approvalData":"styles_approvalData__DUecl"};